import { LitElement, html, TemplateResult, PropertyValues } from 'lit';
import { property, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import IconSet from '../../gzIcon/GzIconSet';
import { FontSize } from '../../gzIconButton/types';
import { IconSets } from '../../../theme';

export class GzIconLabelWebComponent extends LitElement {
  /**
   * This property sets the icon by name.
   */
  @property({ type: String, attribute: true, reflect: true })
  icon;

  @property({ type: String, attribute: true, reflect: true })
  label = '';

  @property({ type: Boolean, attribute: true, reflect: true })
  active = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  isEllipsis = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  uppercase = true;

  /**
   * This property changes the size of the svg icon.
   */

  @property({ type: String, reflect: true })
  size: FontSize = FontSize.ICON_SIZE_18;

  /**
   * This property changes the color of the icon for fontFamily icon.
   */

  @property({ type: String, attribute: true, reflect: true })
  iconColor = 'inherit';

  /**
   * This property decides if the component should load a custom icon set.
   */

  @property({ type: String, attribute: true, reflect: true })
  customIconSet?: keyof typeof IconSets = undefined;

  @state()
  private iconSetInstance: IconSet;

  static get styles() {
    return styles;
  }

  constructor() {
    super();
    this.iconSetInstance = IconSet.getInstance();
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);

    if (this.customIconSet) {
      this.setCustomIconSet(IconSets[this.customIconSet]);
    }
  }

  render() {
    return html`
      <button @click="${this.clickHandler}" id="iconLabelBtn" class="icon-button">
        <span class="button-text">
          ${this.renderIconElement()}
          <span class="label" part="highlightable label">${this.label}</span>
        </span>
      </button>
    `;
  }

  private renderIconElement(): TemplateResult {
    if (this.iconSetInstance.isSVGIconAvailable(this.icon)) {
      return html`<gz-icon
        .name="${this.icon}"
        .size="${this.size}"
        .color="${this.iconColor}"
        exportparts="highlightable"
        part="icon"
      ></gz-icon>`;
    } else {
      return html`<span
        class="icon ${this.icon} pr-1"
        style="color:${this.iconColor}; font-size:${this.size}px"
        part="highlightable icon"
      ></span>`;
    }
  }

  setCustomIconSet(iconSet: TemplateResult) {
    this.iconSetInstance.loadCustomIconSet(iconSet);
  }

  setLabelColor(color) {
    this.style.setProperty('--label-color', color);
  }

  clickHandler(event: Event) {}
}
